export const actorsEndpoint = "https://swapi.py4e.com/api/people/";
